import { render } from "./TouchTableStories.vue?vue&type=template&id=7fc208c6&scoped=true&ts=true"
import script from "./TouchTableStories.vue?vue&type=script&lang=ts"
export * from "./TouchTableStories.vue?vue&type=script&lang=ts"

import "./TouchTableStories.vue?vue&type=style&index=0&id=7fc208c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc208c6"]])

export default __exports__